<template>
  <div>
    <v-toolbar dark class="secondaryColorBackground">
      <v-toolbar-title>{{$t('seleccionaUnCliente')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="fClose">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <v-flex xs12 md8 class="px-3 py-0 my-auto">
        <v-text-field v-model="dSearchCLTE" clearable :label="this.$t('filtrarClientes')" class="searchItem" append-icon="search" @click:append="fBuscarClientes"></v-text-field>
      </v-flex>
      <v-data-table :headers="dHeadersCLTE" :items="dClientes" :no-data-text="this.$t('noResultados')" :no-results-text="this.$t('noResultados')" :pagination.sync="dPaginationCLTE" :loading="dLoadingCLTE" :total-items="dTotalItemsCLTE" :rows-per-page-items="dRowsPerPageArrayCLTE" class="data-tableClientes">
        <template slot="items" slot-scope="props">
          <tr @click="fSelectClient(props)" :id="props.item.cliente" :active="props.selected" :style="fActiveStyleTR(props)">
            <td class="text-xs-right pl-0 pr-3" :style="fActiveStyleTD(props)">
              <span class="resumClienteText">{{ props.item.cliente }}</span>
            </td>
            <td class="text-xs-left px-3" :style="fActiveStyleTD(props)">
              <p class="resumClienteText cursorPointer mb-0">
                {{ props.item.nombre  }}
              </p>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>

// SERVICIOS
import SrvGeneral from '@/services/srv-general'

export default {
  name: 'ShpClientSearch',
  data () {
    return {
      dHeadersCLTE: [
        { text: this.$t('codigoCliente'), align: 'right', value: 'cliente', sortable: false },
        { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', sortable: false }
      ],
      dSearchCLTE: '',
      dTimerSearchCLTE: null,
      dPaginationCLTE: { 'sortBy': 'nombre', 'descending': false, 'rowsPerPage': 10, 'page': 1 },
      dClientes: [],
      dTotalItemsCLTE: 0,
      dRowsPerPageArrayCLTE: [10],
      dLoadingCLTE: false,
      dLastCustomerSearch: null,
      dOpenComponente: true
    }
  },
  created () {
    this.fBuscarClientes()
  },
  methods: {
    fClose () {
      this.$emit('close')
    },
    fBuscarClientes () {
      this.dSelectedClient = {}
      this.fCargaClientes(this.dPaginationCLTE.sortBy, this.dPaginationCLTE.descending, this.dPaginationCLTE.rowsPerPage, this.dSearchCLTE, [])
    },
    fSelectClient (props) {
      this.$emit('select', props)
    },
    fCargaClientes (sortBy, descending, rowsPerPage, search, filters) {
      this.dLoadingCLTE = true
      this.filters = filters

      let offset = 1

      if (sortBy === undefined) {
        sortBy = 'cliente'
        descending = 'ASC'
      }

      descending = (descending) ? 'DESC' : 'ASC'
      this.dPaginationCLTE.page = (this.dPaginationCLTE.page === undefined || search !== this.dLastCustomerSearch) ? 1 : this.dPaginationCLTE.page
      rowsPerPage = (rowsPerPage === undefined) ? this.dPaginationCLTE.rowsPerPage : rowsPerPage
      filters = (filters === undefined) ? [] : filters

      this.dLastCustomerSearch = search

      offset = this.dPaginationCLTE.rowsPerPage * (this.dPaginationCLTE.page - 1) + 1

      // revisar la carga de datos y las columnas
      const jsonEntrada = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        empresa: this.$store.getters.getAutenticacion.empresa,
        searchCols: 'cliente,nombre', // Desde la web solo consultamos 5 anyos para hacer que la consulta vaya más rápida. NO tiene sentido consultar pedidos más antiguos desde la web
        offset: offset,
        numRows: rowsPerPage,
        orderBy: sortBy,
        order: descending,
        filters: filters
      }
      if (localStorage.getItem('isOnPremise') === 'yes') {
        jsonEntrada.search = search
      } else {
        jsonEntrada.searchClienteIdentFiscalNombreRazonSocial = (search !== undefined && search !== null && search !== '') ? '%' + search + '%' : '%%%'
      }

      if (this.dChkPresupuesto) {
        jsonEntrada.presupuestosSN = 'S'
      }
      if (this.dChkPedidosPendientes) {
        jsonEntrada.pedidosPendientesSN = 'S'
      }

      if (this.dSuReferencia !== '') {
        jsonEntrada.refPedido = this.dSuReferencia
      }

      SrvGeneral.lovClte(jsonEntrada).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const datosClientes = response.data
          this.dClientes = (datosClientes.numReg > 0) ? datosClientes.dataRes : []
          this.dTotalItemsCLTE = datosClientes.numReg
          // this.dNumValidacionesValue = 0
        }
        this.dLoadingCLTE = false
      }).catch(error => {
        console.log(error)
        this.dLoadingCLTE = false
        this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b></br>' + this.$t('errorDefaultDesc'))
      })
    },
    fActiveStyleTR (props) {
      return (this.dSelectedClient === props.item) ? 'background:#FFF' : 'background:#f3f3f3'
    },
    fActiveStyleTD (props) {
      return (this.dSelectedClient === props.item) ? 'font-weight:bold;color:#61a9a3' : 'font-weight:normal;color:#000'
    }
  },
  watch: {
    dSearchCLTE: {
      handler () {
        clearInterval(this.dTimerSearchCLTE)
        this.dTimerSearchCLTE = setTimeout(function () {
          this.fBuscarClientes()
        }.bind(this), 500)
      }
    },
    dPaginationCLTE: {
      handler (newPage, oldPage) {
        this.fCargaClientes(newPage.sortBy, newPage.descending, newPage.rowsPerPage, newPage.search, [])
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/Pedidos/ShpClientSearch.vue